import { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import ViewAppraisal from "./editappraisal";
import { AuthContext } from '../AuthContext';
import { Cog6ToothIcon } from "@heroicons/react/20/solid";

export default function AppraisalForm({
  staffName: initialStaffName,
  role: initialRole,
  staffId: initialStaffId,
  type: initialType,
  location: initialLocation,
  initialFormData = {},
  initialAITrainReport = null,
}) {
    // Question: How does the AppraisalForm component manage form state for a chatbot-style interface?
    // Answer: It uses a single state object, formData, to store all user responses, making it easy to update and access answers as the conversation progresses.

    const [formData, setFormData] = useState(initialFormData || {});

    const user = useContext(AuthContext);
  
    const [staffName, setStaffName] = useState(initialStaffName || "");
    const [role, setRole] = useState(initialRole || "");
    const [staffId, setStaffId] = useState(initialStaffId || "");
    const [location, setLocation] = useState(initialLocation || "");
    const [type, setType] = useState(initialType || "");
    const [trainingDocuments, setTrainingDocuments] = useState([]);
    const [navApprasial, setNavApprasial] = useState(false);
    const [loading, setLoading] = useState(false);
    const [AITrainReport, setAITrainReport] = useState(initialAITrainReport || null);
  
    const navigate = useNavigate();
  
    // Update state when props change (in case parent component re-renders with new values)
    useEffect(() => {
      setStaffName(initialStaffName);
      setRole(initialRole);
      setStaffId(initialStaffId);
      setLocation(initialLocation);
      setType(initialType);
    }, [initialStaffName, initialRole, initialStaffId, initialType, initialLocation]);

    useEffect(() => {
      if (initialFormData && Object.keys(initialFormData).length > 0) {
        setFormData(initialFormData);
      }
    }, [initialFormData]);

    useEffect(() => {
      if (initialAITrainReport) {
        setAITrainReport(initialAITrainReport);
        setFormData((prev) => ({ ...prev, AITrainReport: initialAITrainReport }));
      }
    }, [initialAITrainReport]);
  
    const handleChange = (e) => {
      const { name, value } = e.target;
      setFormData((prevFormData) => ({
        ...prevFormData,
        [name]: value,
      }));
    };

    const token = localStorage.getItem('token');

  
    const handleSubmit = async (e) => {
      e.preventDefault();


      console.log(formData);
  
      // Ensure all required fields are filled before submitting
      if (!formData.ReviewPeriodFrom || !formData.ReviewPeriodTo || !formData.OverallPerformance) {
        return;
      }
  
      // Include all relevant data in the form object
      const form = {
        StaffName: staffName,
        Role: role,
        Location: location,
        Type: type,
        StaffId: staffId,
        ReviewPeriodFrom: formData.ReviewPeriodFrom,
        ReviewPeriodTo: formData.ReviewPeriodTo,
        OverallPerformance: formData.OverallPerformance,
        KeyStrengths: formData.KeyStrengths,
        AreasForImprovement: formData.AreasForImprovement,
        PerformanceGoalsMet: formData.PerformanceGoalsMet,
        ExamplesExceedingExpectations: formData.ExamplesExceedingExpectations,
        DeadlinesTargetsMet: formData.DeadlinesTargetsMet,
        LeadershipTeamworkSkills: formData.LeadershipTeamworkSkills,
        FeedbackFromPeers: formData.FeedbackFromPeers,
        DevelopmentGoals: formData.DevelopmentGoals,
        RecommendedTrainingCourses: formData.RecommendedTrainingCourses,
        SkillsForCareerAdvancement: formData.SkillsForCareerAdvancement,
        CompensationBenefitsUpdates: formData.CompensationBenefitsUpdates,
        OverallSummary: formData.OverallSummary,
        RoleResponsibilityChanges: formData.RoleResponsibilityChanges,
        ActionPlan: formData.ActionPlan,
        AITrainingReport : AITrainReport,
        Author : user.StaffName
      };
  
      try {
        const response = await fetch("https://api.insightos.co.uk/api/appraisal", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          credentials : 'include',
          body: JSON.stringify(form),
        });
  
        if (response.ok) {
            navigate('/viewappraisal', { state: { id: staffId } });
        } else {
          console.error("Failed to submit form");
        }
      } catch (error) {
        console.error("Error submitting form:", error);
      }
    };
  
    useEffect(() => {
      const fetchTrainingDocuments = async () => {
        try {
          const response = await fetch("https://api.insightos.co.uk/api/trainingdocuments", {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
            credentials : 'include',
          });
  
          if (response.ok) {
            const data = await response.json();
            const groupedData = data.data.reduce((acc, item) => {
              const { TrainingDocName, Title, Page, Code } = item;
  
              if (!acc[TrainingDocName]) {
                acc[TrainingDocName] = { TrainingDocName, Pages: [] };
              }
  
              acc[TrainingDocName].Pages.push({ Title, Page, Code });
              return acc;
            }, {});
  
            const groupedArray = Object.values(groupedData).map((group) => ({
              ...group,
              Pages: group.Pages.sort((a, b) => a.Page - b.Page),
            }));
  
            setTrainingDocuments(groupedArray);
          } else {
            console.error("Failed to fetch training documents");
          }
        } catch (error) {
          console.error("Error:", error);
        }
      };
  
      fetchTrainingDocuments();
    }, []);

    if (navApprasial) {
        return (
            <ViewAppraisal id={navApprasial} />

        )
  
    }

    const handleAIReport = async () => {
      setLoading(true);
      try {
          const response = await fetch("https://api.insightos.co.uk/api/trainingaireport", {
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
              },
              credentials: 'include',

              body: JSON.stringify({ staffId: staffId }),

          });
  
          if (!response.ok) {
              throw new Error(`Failed to generate AI report: ${await response.text()}`);
          }
  
          const result = await response.json();

            if (response.status === 202 && result.queued && result.jobId) {
              navigate(`/job-progress/${result.jobId}`, {
                state: {
                  title: 'Generating AI training report',
                  successPath: '/appraisals',
                  backPath: '/appraisals',
                  successState: {
                    appraisalDraft: {
                      selected: {
                        id: staffId,
                        Name: staffName,
                        Role: role,
                      },
                      type,
                      location,
                      formData: {
                        ...formData,
                        AITrainReport,
                      },
                    },
                  },
                },
              });
              return;
            }

          console.log("AI Report:", result.report);
          
          setAITrainReport(result.report);
          setFormData((prev) => ({ ...prev, AITrainReport: result.report }));
      } catch (error) {
          console.error("Error generating AI report:", error);
      } finally {
          setLoading(false);
      }
  };
  
  
  return (
    <div className="max-w-4xl mx-auto p-6 bg-white shadow-lg rounded-lg">
      <h2 className="text-2xl font-semibold mb-6">Appraisal Form (Performance Review)</h2>

      <div className="flex justify-end">
      <button onClick={ handleAIReport }
        type="button"
        className="inline-flex items-center gap-x-2 rounded-md bg-indigo-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
      >
        <Cog6ToothIcon aria-hidden="true" className="-ml-0.5 size-5" />
        Generate AI Training Report
      </button>
      </div>
      {loading && <p className="text-sm text-gray-500 mt-4">Generating AI report...</p>}


      <form onSubmit={handleSubmit}>
        {/* Performance Evaluation */}
        <div className="mb-6">
          <h3 className="font-semibold text-lg mb-2">Performance Evaluation</h3>
          <p className="text-sm text-bold text-purple-500 mb-4"> Employee Name: {staffName} </p>
          <p className="text-sm text-bold text-purple-500 mb-4"> Role: {role} </p>
            <p className="text-sm text-bold text-purple-500 mb-4"> Location: {location} </p>
            <p className="text-sm text-bold text-purple-500 mb-4"> Type: {type} </p>

          <div className="grid grid-cols-1 gap-4">
            <div>
              <label htmlFor="ReviewPeriodFrom" className="block text-sm font-medium text-gray-700">
                Review Period From
              </label>
              <input
                type="date"
                id="ReviewPeriodFrom"
                name="ReviewPeriodFrom"
                value={formData.ReviewPeriodFrom}
                onChange={handleChange}
                className="mt-1 block w-full px-4 py-2 border rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
              />
            </div>

            <div>
              <label htmlFor="ReviewPeriodTo" className="block text-sm font-medium text-gray-700">
                Review Period To
              </label>
              <input
                type="date"
                id="ReviewPeriodTo"
                name="ReviewPeriodTo"
                value={formData.ReviewPeriodTo}
                onChange={handleChange}
                className="mt-1 block w-full px-4 py-2 border rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
              />
            </div>

            <div>
              <label htmlFor="OverallPerformance" className="block text-sm font-medium text-gray-700">
                How would you rate the employee’s overall performance?
              </label>
              <select
                id="OverallPerformance"
                name="OverallPerformance"
                value={formData.OverallPerformance}
                onChange={handleChange}
                className="mt-1 block w-full px-4 py-2 border rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
              >
                <option value="">Select Rating (1-5)</option>
                {[1, 2, 3, 4, 5].map((rating) => (
                  <option key={rating} value={rating}>
                    {rating}
                  </option>
                ))}
              </select>
            </div>

            <div>
              <label htmlFor="KeyStrengths" className="block text-sm font-medium text-gray-700">
                What are the employee’s key strengths?
              </label>
              <textarea
                id="KeyStrengths"
                name="KeyStrengths"
                value={formData.KeyStrengths}
                onChange={handleChange}
                rows="4"
                className="mt-1 block w-full px-4 py-2 border rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
              />
            </div>

            <div>
              <label htmlFor="AreasForImprovement" className="block text-sm font-medium text-gray-700">
                What areas could the employee improve on?
              </label>
              <textarea
                id="AreasForImprovement"
                name="AreasForImprovement"
                value={formData.AreasForImprovement}
                onChange={handleChange}
                rows="4"
                className="mt-1 block w-full px-4 py-2 border rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
              />
            </div>

            <div>
              <label htmlFor="PerformanceGoalsMet" className="block text-sm font-medium text-gray-700">
                Has the employee met their performance goals?
              </label>
              <select
                id="PerformanceGoalsMet"
                name="PerformanceGoalsMet"
                value={formData.PerformanceGoalsMet}
                onChange={handleChange}
                className="mt-1 block w-full px-4 py-2 border rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
              >
                <option value="">Select Yes/No</option>
                <option value="yes">Yes</option>
                <option value="no">No</option>
              </select>
            </div>

            <div>
              <label htmlFor="ExamplesExceedingExpectations" className="block text-sm font-medium text-gray-700">
                Please provide examples of how the employee has exceeded expectations.
              </label>
              <textarea
                id="ExamplesExceedingExpectations"
                name="ExamplesExceedingExpectations"
                value={formData.ExamplesExceedingExpectations}
                onChange={handleChange}
                rows="4"
                className="mt-1 block w-full px-4 py-2 border rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
              />
            </div>
          </div>
        </div>
        <div className="mb-6">
            <h3 className="font-semibold text-lg mb-2">Employee Development</h3>
            <div className="grid grid-cols-1 gap-4">
                <div>
                    <label htmlFor="DeadlinesTargetsMet" className="block text-sm font-medium text-gray-700">
                        Has the employee met deadlines and targets?
                    </label>
                    <select
                        id="DeadlinesTargetsMet"
                        name="DeadlinesTargetsMet"
                        value={formData.DeadlinesTargetsMet}
                        onChange={handleChange}
                        className="mt-1 block w-full px-4 py-2 border rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                    >
                        <option value="">Select Yes/No</option>
                        <option value="yes">Yes</option>
                        <option value="no">No</option>
                    </select>
                </div>

                <div>
                    <label htmlFor="LeadershipTeamworkSkills" className="block text-sm font-medium text-gray-700">
                        How would you rate the employee’s leadership and teamwork skills?
                    </label>
                    <select
                        id="LeadershipTeamworkSkills"
                        name="LeadershipTeamworkSkills"
                        value={formData.LeadershipTeamworkSkills}
                        onChange={handleChange}
                        className="mt-1 block w-full px-4 py-2 border rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                    >
                        <option value="">Select Rating (1-5)</option>
                        {[1, 2, 3, 4, 5].map((rating) => (
                            <option key={rating} value={rating}>
                                {rating}
                            </option>
                        ))}
                    </select>
                </div>

                <div>
                    <label htmlFor="FeedbackFromPeers" className="block text-sm font-medium text-gray-700">
                        What feedback have you received from peers about the employee?
                    </label>
                    <textarea
                        id="FeedbackFromPeers"
                        name="FeedbackFromPeers"
                        value={formData.FeedbackFromPeers}
                        onChange={handleChange}
                        rows="4"
                        className="mt-1 block w-full px-4 py-2 border rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                    />
                </div>

                <div>
                    <label htmlFor="DevelopmentGoals" className="block text-sm font-medium text-gray-700">
                        What are the employee’s development goals?
                    </label>
                    <textarea
                        id="DevelopmentGoals"
                        name="DevelopmentGoals"
                        value={formData.DevelopmentGoals}
                        onChange={handleChange}
                        rows="4"
                        className="mt-1 block w-full px-4 py-2 border rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                    />
                </div>
            </div>
        </div>
        <div className="mb-6">
            <h3 className="font-semibold text-lg mb-2">Training & Development</h3>
            <div className="grid grid-cols-1 gap-4">
                <div>
                    <label htmlFor="RecommendedTrainingCourses" className="block text-sm font-medium text-gray-700">
                        What training courses would you recommend for the employee?
                    </label>
                    <select
                        id="RecommendedTrainingCourses"
                        name="RecommendedTrainingCourses"
                        value={formData.RecommendedTrainingCourses}
                        onChange={handleChange}
                        className="mt-1 block w-full px-4 py-2 border rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                    >
                        <option value="">Select Training Course</option>
                        {trainingDocuments.map((doc) => (
                            <option key={doc.TrainingDocName} value={doc.TrainingDocName}>
                                {doc.TrainingDocName}
                            </option>
                        ))}
                    </select>
                </div>
                <div>
                    <label htmlFor="AITrainReport" className="block text-sm font-medium text-gray-700">
                        AI Training Report
                    </label>
                    <p className="text-sm text-gray-500"> {AITrainReport ? AITrainReport : "No AI Training Report"} </p>
                       
                    
                </div>



                <div>
                    <label htmlFor="SkillsForCareerAdvancement" className="block text-sm font-medium text-gray-700">
                        What skills should the employee develop for career advancement?
                    </label>
                    <textarea
                        id="SkillsForCareerAdvancement"
                        name="SkillsForCareerAdvancement"
                        value={formData.SkillsForCareerAdvancement}
                        onChange={handleChange}
                        rows="4"
                        className="mt-1 block w-full px-4 py-2 border rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                    />
                </div>

                <div>
                    <label htmlFor="CompensationBenefitsUpdates" className="block text-sm font-medium text-gray-700">
                        Are there any updates to the employee’s compensation and benefits?
                    </label>
                    <textarea
                        id="CompensationBenefitsUpdates"
                        name="CompensationBenefitsUpdates"
                        value={formData.CompensationBenefitsUpdates}
                        onChange={handleChange}
                        rows="4"
                        className="mt-1 block w-full px-4 py-2 border rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                    />
                </div>
            </div>
        </div>
        <div className="mb-6">
            <h3 className="font-semibold text-lg mb-2">Overall Summary</h3>
            <div className="grid grid-cols-1 gap-4">
                <div>
                    <label htmlFor="OverallSummary" className="block text-sm font-medium text-gray-700">
                        Please provide an overall summary of the employee’s performance.
                    </label>
                    <textarea
                        id="OverallSummary"
                        name="OverallSummary"
                        value={formData.OverallSummary}
                        onChange={handleChange}
                        rows="4"
                        className="mt-1 block w-full px-4 py-2 border rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                    />
                </div>

                <div>
                    <label htmlFor="RoleResponsibilityChanges" className="block text-sm font-medium text-gray-700">
                        Are there any changes to the employee’s role or responsibilities?
                    </label>
                    <textarea
                        id="RoleResponsibilityChanges"
                        name="RoleResponsibilityChanges"
                        value={formData.RoleResponsibilityChanges}
                        onChange={handleChange}
                        rows="4"
                        className="mt-1 block w-full px-4 py-2 border rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                    />

                    <div>
                        <label htmlFor="ActionPlan" className="block text-sm font-medium text-gray-700">
                            What is the action plan for the employee moving forward?
                        </label>
                        <textarea
                            id="ActionPlan"
                            name="ActionPlan"
                            value={formData.ActionPlan}
                            onChange={handleChange}
                            rows="4"
                            className="mt-1 block w-full px-4 py-2 border rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                        />
                    </div>

                    
                </div>
            </div>
        </div>


                    

        {/* Training Documents Section */}
        

        <div className="flex justify-end mt-6">
          <button
            type="submit"
            data-component="appraisal-form-submit"
            data-feature = "appraisal-form-submit"
            time-saved = "30"
            className="inline-flex items-center px-6 py-2 border border-transparent rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
          >
            Submit
          </button>
        </div>
      </form>
    </div>
  );
}
